// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Dj-z","breadcrumbItem":"Ej-z","hideOnMobile":"Fj-z"};